
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import useSubscriberManager from '@/composables/subscribers/subscribersManager'
import ALoader from '@/components/ALoader.vue'
import FollowerUserItem from '@/components/Profile/Lists/Single/FollowerUserItem.vue'
import UserHeader from '@/components/Profile/Lists/Single/UserHeader.vue'
import { useProfileShow } from '@/composables/user/user'
import { useRouter } from '@/routing/router'

export default defineComponent({
  name: 'FollowersList',
  components: {
    UserHeader,
    FollowerUserItem,
    ALoader,
    AButton,
  },
  props: {
    allowNest: {
      type: Boolean,
      default: true,
    },
  },
  async setup() {
    const {
      subscribers,
      remaining,
      loading,
      loadNext,
      clearList,
    } = useSubscriberManager()

    clearList()
    await loadNext()

    return {
      subscribers,
      remaining,
      loading,
      loadNext,
      ...useProfileShow(),
      ...useRouter(),
    }
  },
})
